import { Button } from '@/components/shadcn/ui/button';

import { useFormContext } from './form';

interface FormSubscribeButtonProps extends React.ComponentProps<
  typeof Button
> {}

export function FormSubscribeButton({
  children,
  type = 'submit',
  ...props
}: FormSubscribeButtonProps) {
  const form = useFormContext();

  return (
    <form.Subscribe selector={(state) => state.isSubmitting}>
      {(isSubmitting) => (
        <Button type={type} disabled={isSubmitting} {...props}>
          {children}
        </Button>
      )}
    </form.Subscribe>
  );
}
